<template>
  <BootstrapTable
    :columns="columns"
    :data-url="data"
    :options="options"
    data-side-pagination="server"
    data-pagination="true"
  />
</template>

<script>
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'

export default {

  beforeMount(){
    
    const mailinglistID = this.mailinglist;

  },
  components: {
    BootstrapTable
  },
  props: ['mailinglist'],
  data () {
    return {
      columns: [
        {
          field: 'first_name',
          title: 'First Name',
          sortable: true,
          formatter: function(value, row, index, field){
            if(value && row.suppressed){
              return '<del class="text-muted">'+value+'</del>';
            }else{
              return value;
            }
          }
        },
        {
          field: 'last_name',
          title: 'Last Name',
          sortable: true,
          formatter: function(value, row, index, field){
            if(value && row.suppressed){
              return '<del class="text-muted">'+value+'</del>';
            }else{
              return value;
            }
          }
        },
        {
          field: 'company_name',
          title: 'Company Name',
          sortable: true,
          formatter: function(value, row, index, field){
            if(value && row.suppressed){
              return '<del class="text-muted">'+value+'</del>';
            }else{
              return value;
            }
          }
        },
        {
          field: 'email',
          title: 'Email',
          sortable: true,
          formatter: function(value, row, index, field){
            if(value && row.suppressed){
              return '<del class="text-muted">'+value+'</del>';
            }else{
              return value;
            }
          }
        },
        {
          field: 'telephone',
          title: 'Mobile',
          sortable: true,
          formatter: function(value, row, index, field){
            if(value && row.suppressed){
              return '<del class="text-muted">'+value+'</del>';
            }else{
              return value;
            }
          }
        },
        {
          mailinglist: this.mailinglist,
          field: 'tools',
          title: 'Tools',
          formatter: function(value, row, index, field, mailinglist=this.mailinglist){

            return [
                '<a class="table-control btn btn-outline-primary btn-sm" href="/contacts/mailinglist/'+mailinglist+'/contact/edit/'+row.contact_id+'" title="View Contact Details">',
                  '<i class="fa fa-user"></i> View',
                '</a>',
              ].join('');

          },
          width: 160,
          align: 'center',
        }
      ],
      data: '/contacts/mailinglist/'+this.mailinglist+'/contacts/list',
      options: {
        search: true,
      }
    }
  }
}




</script>